import React from 'react';
import { useSelector } from "react-redux";
import { PhoneOutlined } from '@ant-design/icons';
import {
    Button, Grid, theme, Typography,
} from "antd";
import { clearLocalStore } from 'helpers/localStoreSrv';
const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Title } = Typography;
const AppointmentScheduleByCall = () => {
    const uiState = useSelector((state: any) => state.portal.uiState);
    console.log(uiState.appointmentCallforwardState);
    const { token } = useToken();
    const screens = useBreakpoint();
    const styles = {
        container: {
            margin: "0 auto",
            padding: screens.md ? `${token.paddingXL}px` : `${token.sizeXXL}px ${token.padding}px`,
            width: "380px"
        },
        footer: {
            marginTop: token.marginLG,
            textAlign: "center",
            width: "100%"
        },
        forgotPassword: {
            float: "right"
        },
        header: {
            marginBottom: token.marginXL
        },
        section: {
            alignItems: "center",
            backgroundColor: token.colorBgContainer,
            display: "flex",
            padding: screens.md ? `${token.sizeXXL}px 0px` : "0px"
        },
        text: {
            color: token.colorTextSecondary
        },
        title: {
            fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3
        }
    };
    const handleAction = () => {
        let ref = uiState.appointmentCallforwardState?.contentRef;
        clearLocalStore();
        window.location.href = `tel:${ref}`;
    }
    return (
        <section style={styles.section}>
            <div style={styles.container} data-testid="appointment-schedule-by-call">
                <div style={styles.header}>
                    <Title style={styles.title}>{uiState.appointmentCallforwardState?.contentText}</Title>
                </div>
                <div style={styles.header}>
                    {uiState.appointmentCallforwardState?.contentRef && <Button type="primary" shape="circle" icon={<PhoneOutlined style={{ fontSize: '40px', margin: '20px' }} />} size={'large'} style={{ 'height': '100px', width: '100px' }} onClick={handleAction} />}
                </div>
            </div>
        </section>
    )
}
export default AppointmentScheduleByCall